import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import MiniDrawer from './components/MiniDrawer';
import { BrowserRouter as Router, Link as RouterLink } from "react-router-dom";
import { Route } from "react-router";
import { Button, ThemeProvider } from '@mui/material';
import Login from './components/Login';
import appTheme from './theme';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

export default function App() {
    return (
        
        <Router>
            <ThemeProvider theme={appTheme}>
               
                <Route path="/" exact>

                        <MiniDrawer />
            </Route>
            <Route path="/login">

                    <Login />

                </Route>

                <Route path="/forgotPassword">

                    <ForgotPassword />

                </Route>

                <Route path="/resetPassword">

                    <ResetPassword />

                </Route>
                    <ToastContainer />
            </ThemeProvider>
            </Router>

  );
}